export default {
  geolocation: {
    lat: '52.3738',
    lng: '4.8910',
    label: '1000 Amsterdam',
  },
  price_rules: {
    grouping: '.',
    decimal: ',',
  },
}
